// extracted by mini-css-extract-plugin
export default {"background":"Bonuses_background__nu6fW","table":"Bonuses_table__by2nz","firstName":"Bonuses_firstName__mezQb","pagination":"Bonuses_pagination__nvsOG"};